import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from '@mui/material';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { setLogoutDialogOpen } from '../../store/authSlice';
import { useSelector, useDispatch } from "react-redux";
import disconnectIcon from "../../../../assets/disconexion.png";
import "./Logout.css";
import { getTenantByDomain, logoutGuestUser } from '../../store/authThunks';
import KeycloakSingleton from '../../../../features/Auth/utils/keycloakSingleton';

import { getSubDomain, clearLocalStorage } from '../../utils/AuthUtils.js';
import { setMenuIsOpen } from ".././../../ControlPanel/store/controlPanelSlice.js";
export default function Logout() {
    const { t } = useTranslation();
    const subDomain = getSubDomain()
    const dispatch = useDispatch();
    const {
        logoutDialogOpen,
        isGuest,
        isGuestDemo
    } = useSelector((state) => state.auth);



    const logoutUser = async () => {
        const tenant = await dispatch(
            getTenantByDomain({ params: [{ subDomain }] })
        ).unwrap();
        try {

            if (isGuest) {
                const tenantId = tenant?.tenant?.id;
                const refresh_token = localStorage.getItem("refresh_token");
                const email = localStorage.getItem("email");
                const demoToken = localStorage.getItem("demoToken");
                const demoMapId = localStorage.getItem("demoMapId");
                const code = localStorage.getItem("code");

                dispatch(logoutGuestUser({ body: { email, refresh_token, tenantId } }));

                let redirectUrl = "/";

                if (isGuestDemo) {
                    if (demoToken) {
                        redirectUrl = `/guest/demo?d=${encodeURIComponent(demoToken)}`;
                    } else if (demoMapId) {
                        redirectUrl = `/guest/demo/${demoMapId}`;
                    } else {
                        redirectUrl = `/guest/demo`;
                    }
                } else {
                    redirectUrl = `/guest/${code}`;
                }

                clearLocalStorage();
                localStorage.removeItem("welcomeModalSeen");

                window.location.href = redirectUrl;
                return;
            }

            const keycloak = KeycloakSingleton.getInstance();
            keycloak.logout();
            localStorage.removeItem("welcomeModalSeen");
        } catch (e) {
            console.log(e);
        }
    }

    const toggleMenu = () => {
        //setMenuIsOpen(false);
        dispatch(setMenuIsOpen(false));
        document.body.classList.remove('main-menu-open');
    };

    return (
        <>
            <div className="logout" onClick={() => {dispatch(setLogoutDialogOpen(true));toggleMenu()}}>
                <img src={disconnectIcon} />
            </div>


            {logoutDialogOpen && <Dialog open={logoutDialogOpen} onClose={() => dispatch(setLogoutDialogOpen(false))} PaperProps={{
                sx: {
                    borderRadius: '1rem',
                },
            }}>
                <DialogTitle>
                    <div className="title-dialog">
                        <h2>
                            <img src={disconnectIcon} />
                            {t("logout_confirmation_dialog_header")}
                        </h2>
                        <span class="material-symbols-outlined cursor-pointer" onClick={() => dispatch(setLogoutDialogOpen(false))} >
                            close
                        </span>
                    </div>
                </DialogTitle>
                <DialogContent sx={{ mt: '1.5rem', mb: '2rem' }}>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Typography>{t("logout_confirmation_dialog_message1")}</Typography>
                        <Typography>{t("logout_confirmation_dialog_message2")}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions className='actions-dialog'>
                    <Button className='btn-actions-dialog-cancel' onClick={() => dispatch(setLogoutDialogOpen(false))} >
                        {t("cancel")}
                    </Button>
                    <Button className='btn-actions-dialog-confirm' onClick={logoutUser} color="primary" variant="contained">
                        {t("logout")}
                    </Button>
                </DialogActions>
            </Dialog>
            }
        </>
    );
};

